import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { Box, useTheme } from '@mui/material';
import React from 'react';

const TicketIcon = ({ boxSize, iconSize }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: boxSize,
        height: boxSize,
        borderRadius: '50%',
        backgroundColor: theme.palette.icon.tickets.background,
      }}
    >
      <ConfirmationNumberIcon
        sx={{
          color: theme.palette.icon.tickets.contrast,
          fontSize: iconSize,
        }}
      />
    </Box>
  );
};

export default TicketIcon;
